module.exports = __webpack_public_path__ + "static/media/DUYEN_HAI.583ac6ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/TestimonialsCarousel/assets/DUYEN_HAI.jpg
// module id = 1115
// module chunks = 0